<div class="dialog">
  <h4 mat-dialog-title>{{ data.title }}</h4>
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <mat-form-field *ngIf="!newSolution">
      <mat-label>{{ 'dialog_copy_project_ecopro_field_scenario_existing' | translate }}</mat-label>
      <mat-select formControlName="solutionTarget">
        <mat-option *ngFor="let solution of solutionsTarget" [value]="solution"> {{ solution.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox formControlName="newSolution" (change)="newSolutionChange($event)">{{ 'dialog_copy_project_ecopro_checkbox_new' | translate }}</mat-checkbox>
    <mat-form-field class="mt-2" *ngIf="newSolution">
      <mat-label>{{ 'dialog_copy_project_ecopro_field_scenario_name' | translate }}</mat-label>
      <input matInput formControlName="newSolutionTarget" />
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="form?.value" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
